import React, { useEffect, useState } from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import Uploady from "@rpldy/uploady";
import { useLocation, useNavigate } from "react-router-dom";
import { useHeader } from "../../Logic/Header/useHeader";
import { useSelector } from "react-redux";
import FileUploadProvider from "../../components/context/FileUploadProvider";
import DashboardComponent from "../../components/DashboardComponent/DashboardComponent";

const DashBoardContainer = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  let navigate = useNavigate();
  const { userProfileData } = useHeader();

  let b = false | true;

  useEffect(() => {
    if (
      location.pathname.startsWith("/dashboard") &&
      location.pathname !== "/user-plans"
    ) {
      document.body.setAttribute(
        "data-theme",
        localStorage.getItem("photofindtheme")
      );
    } else {
      document.body.setAttribute("data-theme", "default");
    }
  }, []);

  useEffect(() => {
    if (userProfileData?.theme_class_name !== undefined) {
      localStorage.setItem("photofindtheme", userProfileData?.theme_class_name);
      document.body.setAttribute(
        "data-theme",
        userProfileData?.theme_class_name
      );
    }
  }, [userProfileData?.theme_class_name]);

  useEffect(() => {
    if (userProfileData.plan_payment_status === 0) {
      navigate("/plans");
    }
  }, [userProfileData]);

  return (
    <div className="dashboard_container">
      <CommonLayout
        pageClass={`dashboard ${isCollapsed ? "sidebar-collapsed" : ""}`}
        noFooter
      >
        <DashboardComponent
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      </CommonLayout>
    </div>
  );
};

export default DashBoardContainer;
